export const BUSINESS_CATEGORIES = [
  { id: 'restaurante', name: 'Restaurante', icon: 'Utensils' },
  { id: 'restobar', name: 'Restobar', icon: 'Wine' },
  { id: 'cafeteria', name: 'Cafeteria', icon: 'Coffee' },
  { id: 'bar', name: 'Bar', icon: 'Beer' },
  { id: 'panaderia', name: 'Panaderia', icon: 'Croissant' },
  { id: 'carretas', name: 'Carretas', icon: 'Truck' },
  { id: 'agachadito', name: 'Agachadito', icon: 'Flame' },
  { id: 'heladeria', name: 'Heladeria', icon: 'IceCream' },
  { id: 'tienda_gourmet', name: 'Tienda Gourmet', icon: 'Store' },
  { id: 'tienda_de_barrio', name: 'Tienda de Barrio', icon: 'ShoppingBasket' },
  { id: 'sala_de_juegos', name: 'Sala de Juegos', icon: 'Gamepad2' },
  { id: 'club', name: 'Club', icon: 'Music' },
  { id: 'foto_estudio', name: 'Foto Estudio', icon: 'Camera' },
  { id: 'parque', name: 'Parque', icon: 'Trees' },
  { id: 'bazar', name: 'Bazar', icon: 'ShoppingBag' },
  { id: 'tecnologia', name: 'Tecnologia', icon: 'Smartphone' },
];

export const CUISINE_TYPES = [
  { id: 'italiana', name: 'Italiana' },
  { id: 'mexicana', name: 'Mexicana' },
  { id: 'peruana', name: 'Peruana' },
  { id: 'japonesa', name: 'Japonesa' },
  { id: 'china', name: 'China' },
  { id: 'americana', name: 'Americana' },
  { id: 'ecuatoriana', name: 'Ecuatoriana' },
  { id: 'colombiana', name: 'Colombiana' },
  { id: 'argentina', name: 'Argentina' },
  { id: 'española', name: 'Española' },
  { id: 'francesa', name: 'Francesa' },
  { id: 'thai', name: 'Thai' },
  { id: 'india', name: 'India' },
  { id: 'fusion', name: 'Fusión' },
  { id: 'internacional', name: 'Internacional' },
  { id: 'otros', name: 'Otros' },
];

export const AMENITIES = [
  { id: 'wifi', name: 'WiFi', icon: 'Wifi' },
  { id: 'estacionamiento', name: 'Estacionamiento', icon: 'Car' },
  { id: 'terraza', name: 'Terraza', icon: 'Sun' },
  { id: 'aire_acondicionado', name: 'Aire Acondicionado', icon: 'Snowflake' },
  { id: 'pet_friendly', name: 'Pet Friendly', icon: 'PawPrint' },
  { id: 'acceso_discapacitados', name: 'Acceso Discapacitados', icon: 'Accessibility' },
  { id: 'reservaciones', name: 'Reservaciones', icon: 'Calendar' },
  { id: 'musica_vivo', name: 'Música en Vivo', icon: 'Music' },
  { id: 'delivery', name: 'Delivery', icon: 'Bike' },
  { id: 'para_llevar', name: 'Para Llevar', icon: 'ShoppingBag' },
];

export const PAYMENT_METHODS = [
  { id: 'efectivo', name: 'Efectivo', icon: 'Banknote' },
  { id: 'tarjeta', name: 'Tarjeta', icon: 'CreditCard' },
  { id: 'transferencia', name: 'Transferencia', icon: 'ArrowLeftRight' },
  { id: 'payphone', name: 'PayPhone', icon: 'Smartphone' },
];

export const DELIVERY_SERVICES = [
  { id: 'pedidosya', name: 'PedidosYa' },
  { id: 'rappi', name: 'Rappi' },
  { id: 'uber_eats', name: 'Uber Eats' },
  { id: 'propio', name: 'Delivery Propio' },
];

export const getCategoryName = (id) => {
  const category = BUSINESS_CATEGORIES.find(c => c.id === id);
  return category ? category.name : id;
};

export const getCuisineName = (id) => {
  const cuisine = CUISINE_TYPES.find(c => c.id === id);
  return cuisine ? cuisine.name : id;
};
